module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('words-cloud-renderer'), _vm._v(" "), _c('a', {
    staticClass: "about",
    attrs: {
      "href": "https://github.com/anvaka/common-words",
      "title": "about this website..."
    }
  }, [_vm._v("?")]), _vm._v(" "), _c('div', {
    staticClass: "language-picker no-print",
    class: {
      "list-expanded": _vm.listState.expanded
    }
  }, [_c('div', {
    staticClass: "header no-select",
    class: {
      "context-visible": _vm.isContextVisible
    },
    on: {
      "click": _vm.toggleList
    }
  }, [_vm._v("\n    Most used words in\n    "), _c('drop-click', {
    attrs: {
      "selected": _vm.languages.selected,
      "items": _vm.languages.list
    },
    on: {
      "selected": _vm.updateSelectedLanguage
    },
    scopedSlots: {
      "item": function(props) {
        return [_c('option', {
          domProps: {
            "value": props.item.extension
          }
        }, [_vm._v(_vm._s(props.item.text))])]
      }
    }
  }), _vm._v(" files\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "word-list"
  }, [_c('div', {
    staticClass: "all-words list",
    class: {
      "context-visible": _vm.isContextVisible
    }
  }, _vm._l((_vm.allWords), function(word) {
    return _c('a', {
      staticClass: "line",
      attrs: {
        "href": "#",
        "title": word.text
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectWord(word.text)
        }
      }
    }, [_c('div', {
      staticClass: "place"
    }, [_vm._v(_vm._s(word.place))]), _vm._v(" "), _c('div', {
      staticClass: "word"
    }, [_vm._v(_vm._s(word.text))]), _vm._v(" "), _c('div', {
      staticClass: "count",
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(word.total))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "context",
    class: {
      "context-visible": _vm.isContextVisible
    }
  }, [_c('div', {
    staticClass: "context-header"
  }, [_c('a', {
    staticClass: "back-to-all",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeContext($event)
      }
    }
  }, [_vm._v("all → ")]), _vm._v(" "), _c('a', {
    staticClass: "context-word",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleList($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.sideBar.header))])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.sideBar.lines), function(line) {
    return _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "parts",
      attrs: {
        "title": line.text
      }
    }, _vm._l((line.parts), function(part) {
      return _c('span', {
        class: {
          highlight: part.bold
        }
      }, [_vm._v(_vm._s(part.text))])
    })), _vm._v(" "), _c('div', {
      staticClass: "count"
    }, [_vm._v(_vm._s(line.count))])])
  }))])]), _vm._v(" "), _c('a', {
    staticClass: "expand-list context-action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleList($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.listState.expanded ? 'hide list' : 'show list'))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fe9442ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 124
// module chunks = 2